export default {
  groupName: 'ford-lincoln',
  appName: 'Lincoln US',
  isAuto: true,
  image: 'ford_lincoln.png',
  baseRoute: '/ford-lincoln',
  description:
  'Lincoln - US Luxury Tier 1/1.5 Advertising Dashboard (Starting Jan 2019)'
}
